import { useState, useEffect, useCallback } from 'react';

/**
 * 检测当前标签页是否激活的 Hook
 * @param {Function} onActive - 标签页激活时的回调函数（可选）
 * @param {Function} onInactive - 标签页失活时的回调函数（可选）
 * @returns {boolean} isTabActive - 当前标签页是否激活（可见）
 */
function useTabActive(onActive, onInactive) {
    // 状态：当前标签页是否激活（初始值取当前页面可见状态）
    const [isTabActive, setIsTabActive] = useState(document.visibilityState === 'visible');

    // 处理标签页可见性变化
    const handleVisibilityChange = useCallback(() => {
        const currentState = document.visibilityState === 'visible';
        setIsTabActive(currentState);

        // 执行自定义回调
        if (currentState) {
            typeof onActive === 'function' && onActive();
        } else {
            typeof onInactive === 'function' && onInactive();
        }
    }, [onActive, onInactive]);

    // 监听 visibilitychange 事件
    useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // 组件卸载时移除监听（避免内存泄漏）
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [handleVisibilityChange]);

    return isTabActive;
}

export default useTabActive;
